// extracted by mini-css-extract-plugin
module.exports = {"socialLoginButton":"styles_socialLoginButton__1ppdz","socialLoginText":"styles_socialLoginText__3iCvN"};